<template>
  <div>xx</div>
</template>
<script>
export default {
  name: 'FormRender',
  props: {
    mode: {
      type: String,
      default: 'DESIGN'
    },
    value: {
      type: String,
      default: undefined
    },
    config: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    validate(call) {
      this.$refs.form.validate(call);
    }
  }
};
</script>

<style lang="less" scoped></style>
